function sofiaFetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function sofiaGetSelectedVariant(sofiaMainProduct) {
  // FIXME: Scope this to .sofia-variant-picker
  const selectedVariant = sofiaMainProduct.querySelector(
    "[data-sofia-selected-variant]"
  )?.innerHTML;
  return !!selectedVariant ? JSON.parse(selectedVariant) : null;
}

function sofiaHandleVariantSelect(selectedOptionValues) {
  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductForm = sofiaMainProduct?.querySelector(".sofia-main-product-form");
  if (!sofiaMainProductForm) return;
  
  const productUrl = sofiaMainProduct.dataset.sofiaUrl;
  if (!productUrl) return;

  sofiaRenderProductInfo({
    requestUrl: sofiaBuildRequestUrlWithParams(productUrl, selectedOptionValues),
    callback: sofiaHandleUpdateProductInfo(productUrl),
  });
}

function sofiaBuildRequestUrlWithParams(url, optionValues) {
  const params = [];

  if (optionValues.length) {
    params.push(`option_values=${optionValues.join(",")}`);
  }

  return `${url}?${params.join("&")}`;
}

function sofiaRenderProductInfo({ requestUrl, callback }) {
  fetch(requestUrl)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );
      callback(html);
    })
    .catch(console.error);
}

function sofiaUpdateVariantInputs(variantId) {
  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductForm = sofiaMainProduct?.querySelector(".sofia-main-product-form");
  if (!sofiaMainProductForm) return;
  
  // TODO: We maybe should make this to update all the inputs (side-cart support?)
  const input = sofiaMainProductForm.querySelector('input[name="id"]');
  input.value = variantId ?? "";
}

function sofiaUpdatePrice(sofiaMainProductPrice) {
  const previousSofiaMainProductPrice = document.querySelector(".sofia-main-product-price");
  if (!previousSofiaMainProductPrice) return;

  previousSofiaMainProductPrice.innerHTML = sofiaMainProductPrice.innerHTML;
}

function sofiaHandleUpdateProductInfo(productUrl) {
  return (html) => {
    const sofiaMainProduct = html.querySelector(".sofia-main-product");
    if (!sofiaMainProduct) return;

    const variant = sofiaGetSelectedVariant(sofiaMainProduct);

    sofiaUpdateURL(productUrl, variant?.id);
    sofiaUpdateVariantInputs(variant?.id);

    const sofiaMainProductPrice = sofiaMainProduct.querySelector(".sofia-main-product-price");
    if (sofiaMainProductPrice) sofiaUpdatePrice(sofiaMainProductPrice);

    if (!variant) return;

    sofiaUpdateMedia(variant?.featured_media?.id);
  };
}

function sofiaUpdateURL(url, variantId) {
  window.history.replaceState(
    {},
    "",
    `${url}${variantId ? `?variant=${variantId}` : ""}`
  );
}

function sofiaUpdateMedia(mediaId) {
  if (!mediaId) return;

  const sofiaMainProduct = document.querySelector(".sofia-main-product");
  const sofiaMainProductGallery = sofiaMainProduct?.querySelector(".sofia-main-product-gallery");
  if (!sofiaMainProductGallery) return;

  const activeMedia =
    sofiaMainProductGallery.querySelector('[data-sofia-media-id="' + mediaId +'"]');
  if (!activeMedia) return;
  
  sofiaMainProductGallery
    .querySelectorAll("[data-sofia-media-id]")
    .forEach((media) => {
      media.classList.remove("sofia-active");
    });
  activeMedia?.classList.add("sofia-active");
  
  window.setTimeout(() => {
    activeMedia.scrollIntoView({ behavior: "instant", inline: "center", block: "nearest" });
  
    const activeMediaRect = activeMedia.getBoundingClientRect();
    // Do not scroll page if active media is already in view
    if (activeMediaRect.top > -0.5) return;
    const top = activeMediaRect.top + window.scrollY;
    window.scrollTo({ top: top, behavior: "smooth" });
  });
}

async function sofiaAddItemsToCart(items, redirect = true) {
  const config = sofiaFetchConfig();
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.body = JSON.stringify({
    items: items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
    })),
  });

  const response = await fetch(window.sofiaRoutes.cart_add_url, config);
  const result = await response.json();

  if (result.errors) {
    throw new Error(
      Array.isArray(result.errors)
        ? result.errors.join(", ")
        : result.errors
    );
  }

  // Enable the Add to Cart button in case the user navigates back to the product page
  const submitButton = document.querySelector('.sofia-main-product-button__submit');
  if (submitButton) submitButton.removeAttribute('aria-disabled');

  if (redirect) {
    window.location = window.sofiaRoutes.cart_url;
  }
}
